  /*============ Content Controller
  ================================*/
  angular
      .module('vppApp') 
      .controller('overviewController', overviewController);

    overviewController.$inject = ['$scope', '$rootScope', '$stateParams', '$state', '$filter', 'vppConfig', 'ProgramInfoService', 'AuthenticationService', 'overviewTableFactory', 'apiFactory', 'TimeOutService', 'CustomerService'];

    function overviewController($scope, $rootScope, $stateParams, $state, $filter, vppConfig, ProgramInfoService, AuthenticationService, overviewTableFactory, apiFactory, TimeOutService, CustomerService){
      var programOrder = vppConfig.programOrder[vppConfig.folderPath];
      $scope.userSuspended = false;
      var pageNumber = 1;
      var programs = 'programs';
      $rootScope.isAuth = AuthenticationService.isAuthenticated();
      $scope.programIDs = CustomerService.getProgramIDs();
      //puts programs in specicic order order
      $scope.programIDs = $filter('sortProgramBy')($scope.programIDs, programOrder);
      $scope.programHistoryContainer = {};

      var accountId = AuthenticationService.getAuthenticatedID();
      var program = ProgramInfoService.getProgram();
      var programCode = ProgramInfoService.getProgramCode();
      var programName = ProgramInfoService.getProgramName();
      programName = programName.replace(/\s+/g, '-').toLowerCase();
      //list of programs that have tables
      var tableList =
        [
          'gmeac'
        ];
      $scope.overviewContent = vppConfig.overviewPaths[programCode];
      //get table for eac programs
      if(tableList.indexOf(programCode.toLowerCase()) > -1){
        overviewTableFactory(programCode).then(function (response) {
          $scope.tableInfo = response.data.tables;
        });
      }

      $scope.gotToAuth = function (id) {

        var id = $scope.programIDs.filter(function (el) {
          return el.code.toLowerCase() == id.toLowerCase();
        })[0];


        var getAuthHistoryForProgram = function (id) {
          var key = 0;
          var programCount = $scope.programIDs.length;
          // Get auth history for each program
          // console.log("programCount: ", programCount);
          for (var i = 0; i < programCount; i++) {
            if (id.programID == $scope.programIDs[i].programID) {
              key = i;
              break;
            }
          }

          // get history if it hasn't been retreived yet
          if (typeof $scope.programHistoryContainer[$scope.programIDs[key].programID] == 'undefined') {
            $scope.programHistoryContainer[$scope.programIDs[key].programID] = {};

            retrieveProgramHistory($scope.programIDs[key].programID, function (retrieveProgramHistoryResponse) {

              if (retrieveProgramHistoryResponse) {
                $scope.programHistoryContainer[retrieveProgramHistoryResponse.data.programID]["programInfo"] = retrieveProgramHistoryResponse.data;

                bindAuthHistoryByProgram(id, key);

                apiFactory.authProgram(accountId, id.programID).then(function (response) {
                  $scope.programInfo = response.data;
                  $scope.KBVExam = $scope.programInfo.moduleResponse.agencyConfigMap.kbv ? true : false;

                  ProgramInfoService.addProgram(id);
                  if ($scope.KBVExam) {
                    $state.go('obtainauth');
                  } else {
                    if ($scope.siteCode == 'frd' || $scope.siteCode == 'mpp' || $scope.siteCode == 'gmed') {
                      $rootScope.isRegistration = false;
                      apiFactory.idMeVerifyUser(accountId).then(function successCallback(response) {
                        $state.go('get-auth');
                      }, function errorCallback(response) {
                        $scope.responsePending = false;
                        $scope.serverError = response.data.errors;
                        $state.go('sign-in');
                      });
                    }else{
                      $state.go('get-auth');
                    }
                  }
                }, function (response) {
                  //console.log('authprogram error', response);
                  if (response.data.errors[0].errorCode == '9050' || response.data.remainingEntitlements == 0) {
                    $scope.entitlementsExceeded = true;
                  }

                  TimeOutService.checkAuthError(response);
                });
              }
            });
          }
        };

        var bindAuthHistoryByProgram = function (id, key) {

          // for (var i = 0; i < $scope.programIDs.length; i++) {

          $scope.programIDs[key]["programs"] = [{
            "authHistory": $scope.programHistoryContainer[$scope.programIDs[key].programID] ? $scope.programHistoryContainer[$scope.programIDs[key].programID]["authHistory"] : [],
            "totalNoOfAuths": $scope.programHistoryContainer[$scope.programIDs[key].programID] ? $scope.programHistoryContainer[$scope.programIDs[key].programID]["authHistory"].length : 0,
            "programID": $scope.programIDs[key].programID,
            "programInfo": $scope.programHistoryContainer[$scope.programIDs[key].programID]["programInfo"]
          }];

          var thisId = $scope.programIDs[key].programID;
          var thisCode = $scope.programIDs[key].code;
          var idLower = thisCode.toLowerCase();
          
        };

        var retrieveProgramHistory = function (thisId, retrieveProgramHistorycallback) {

          apiFactory.authHistory(accountId, thisId, pageNumber).then(function (authHistoryResponse) {
            //console.log("apiFactory.authHistory: ", authHistoryResponse);
            $scope.programHistoryContainer[thisId] = {
              authHistory: [],
              totalNoOfAuths: 0,
              programID: thisId,
              loadedAuths: 0
            }

            if (authHistoryResponse) {
              $scope.programHistoryContainer[thisId]["authHistory"] = authHistoryResponse.data.authHistoryPart;
              $scope.programHistoryContainer[thisId]["totalNoOfAuths"] = authHistoryResponse.data.totalNoOfAuths;
              $scope.programHistoryContainer[thisId].loadedAuths = authHistoryResponse.data.authHistoryPart.length;

              // set DOB and zip code for each record
              var authHistoryLength = $scope.programHistoryContainer[thisId]["authHistory"].length;
              for (var i = 0; i < authHistoryLength; i++) {
                $scope.programHistoryContainer[thisId]['authHistory'][i].dob = $scope.programHistoryContainer[thisId]["authHistory"][i]["authDetails"]["Date of Birth"];
                $scope.programHistoryContainer[thisId]['authHistory'][i].zip = $scope.programHistoryContainer[thisId]["authHistory"][i]["authDetails"]["Postal Code"];
              }
            }

            getAuthProgram(thisId).then(function (response) {

              $scope.userSuspended = response.data.suspension;
              $scope.purchaserNameReq = response.data.purchaserNameReqFlag.toLowerCase();

              //console.log("name required ", response.data.moduleResponse.agencyConfigMap.kbv.examRequired);

              if (typeof retrieveProgramHistorycallback == 'function' && retrieveProgramHistorycallback != undefined) {
                // console.log("$scope.programHistoryContainer[thisId]: ", $scope.programHistoryContainer[thisId]);
                retrieveProgramHistorycallback(response);
              }

            }, function errorCallback(response) {
              if (typeof retrieveProgramHistorycallback == 'function' && retrieveProgramHistorycallback != undefined) {
                // console.log("$scope.programHistoryContainer[thisId]: ", $scope.programHistoryContainer[thisId]);
                retrieveProgramHistorycallback(null);
              }

            });

          }, function errorCallback(response) {
            // $scope.responsePending = false;
            // $scope.serverError = response.data.errors;
            TimeOutService.checkAuthError(response);
            if (typeof retrieveProgramHistorycallback == 'function' && retrieveProgramHistorycallback != undefined) {
              retrieveProgramHistorycallback(null);
            }

          });

        };

        var getAuthProgram = function (programID) {
          // var accountId = AuthenticationService.getAuthenticatedID();
          return apiFactory.authProgram(accountId, programID);
        };

        getAuthHistoryForProgram(id);

      };
  }
